import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=c43a04ac&"
import script from "./ProspectsList.vue?vue&type=script&lang=js&"
export * from "./ProspectsList.vue?vue&type=script&lang=js&"
import style0 from "./ProspectsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports